/**
 * API origin for axios + Socket.io.
 *
 * - If REACT_APP_API_BASE_URL is set → use it (any port, subdomain, or https).
 * - Development (no env): default http://127.0.0.1:5000 — matches backend `PORT` default / typical .env.
 * - Production (no env): "" — relative `/api/...` (nginx proxies to Node).
 */
export function getApiBase() {
  const env = process.env.REACT_APP_API_BASE_URL;
  if (env && String(env).trim()) {
    return String(env).replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:5000";
  }
  return "";
}
